import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { appLoaderAnimationTypes, AppLoaderConfig, IAppLoaderConfig } from '../../interfaces';
import { AppLoaderService } from '../../services';
import { RequestLoaderService } from '@services/request-loader.service';

/* based on ngx-loading */
@Component({
  selector: 'loader-animation',
  templateUrl: './loader-animation.component.html',
  styleUrls: ['./loader-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderAnimationComponent implements OnInit, OnDestroy {
  @Input() public show: boolean;
  @Input() public config: IAppLoaderConfig = new AppLoaderConfig();
  @Input() public template!: TemplateRef<any>;
  @Input() public isAPIBased: boolean;

  public appLoaderAnimationTypes: typeof appLoaderAnimationTypes = appLoaderAnimationTypes;

  private defaultConfig: IAppLoaderConfig = {
    animationType: appLoaderAnimationTypes.threeBounce,
    backdropBackgroundColour: 'rgba(0, 0, 0, 0.3)',
    backdropBorderRadius: '0px',
    fullScreenBackdrop: false,
    primaryColour: '#ffffff',
    secondaryColour: '#ffffff',
    tertiaryColour: '#ffffff',
  };

  constructor(private loaderService: AppLoaderService, public uiService: RequestLoaderService) {}

  public ngOnInit(): void {
    this.setupConfig();

    if (!this.isAPIBased) {
      this.uiService.showUILoader();
    }
  }

  public ngOnDestroy(): void {
    if (!this.isAPIBased) {
      this.uiService.hideUILoader();
    }
  }

  private setupConfig(): void {
    for (const option in this.defaultConfig) {
      if (this.config[option] != null) {
        continue;
      }

      this.config[option] =
        this.loaderService.loadingConfig[option] != null ? this.loaderService.loadingConfig[option] : this.defaultConfig[option];
    }
  }
}
